import { getApiV2Client, getAuditReportsExportGipReportUrl } from '@mi-front/api-v2';
import { GipReportDto } from '@app/modules/audit/modules/global-audit/gip.types';
import { pushTo } from '@app/core/routing';
import { ReportExportInfo } from './components/export-info/ReportExportInfo';
import { GipReportActions } from './components/GipReportActions';
import { GipDetails } from './components/GipReportViewShared';

interface Props {
  readonly report: GipReportDto;
}

export function GipReportDetail({ report }: Props) {
  return (
    <GipDetails
      report={report}
      actions={
        <GipReportActions
          report={report}
          exportFn={(params) =>
            getApiV2Client().generateUrl(getAuditReportsExportGipReportUrl(report.id).url, {
              params,
            })
          }
          onClone={() => {
            pushTo(`/audit/global-reports/gip-report?report=${report.id}`);
          }}
        />
      }
      exportInfo={<ReportExportInfo report={report} />}
    />
  );
}
